<template>
  <div>
    <ModalAppointmentVisitorEdit :isAdmin="isAdmin" />
    <ModalUpdateAdditionalInfo @refreshMap="refreshAppointments" :additional-data="additionalData" />
    <ModalUpdateAdditionalInfoConfirmToClose />

    <AdminAppointmentChangeKeyLocation />
    <AdminAppointmentChangeStatus />
    <AdminAppointmentQuoteReopen />
    <AdminAppointmentChangeDate />
    <AdminAppointmentAddHost />
    <AdminAppointmentChangeHost />
    <AppointmentChangeInspector />
    <AdminAppointmentChangeType />
    <AppointmentReschedule :isAdmin="isAdmin" />
    <AppointmentCancel :isAdmin="isAdmin" />
    <AppointmentUpdateObservations />
    <AppointmentUpdateDisplacement />

    <ModalConfirmAppointmentManually @refreshMap="refreshAppointments" :appointment="appointmentToConfirm" />
    <ModalBulkReschedule @refreshMap="refreshAppointments" :selectedAppointments="selectedAppointments" />
    <ModalBulkCancel @refreshMap="refreshAppointments" :selectedAppointments="selectedAppointments" />
    <ModalBulkSendConfirmationEmail @refreshMap="refreshAppointments" :selectedAppointments="selectedAppointments" />
  </div>
</template>

<script>
import AppointmentCancel from '@/components/appointment/AppointmentCancel'
import AppointmentReschedule from '@/components/appointment/AppointmentReschedule'

import AdminAppointmentAddHost from '@/components/appointment/AdminAppointmentAddHost'
import AdminAppointmentChangeDate from '@/components/appointment/AdminAppointmentChangeDate'
import AdminAppointmentChangeHost from '@/components/appointment/AdminAppointmentChangeHost'
import AdminAppointmentChangeType from '@/components/appointment/AdminAppointmentChangeType'
import AdminAppointmentQuoteReopen from '@/components/appointment/AdminAppointmentQuoteReopen'
import AdminAppointmentChangeStatus from '@/components/appointment/AdminAppointmentChangeStatus'
import AdminAppointmentChangeKeyLocation from '@/components/appointment/AdminAppointmentChangeKeyLocation'

import ModalGroupSetHost from '@/components/appointment/modals/ModalGroupSetHost'
import ModalGroupRemoveHost from '@/components/appointment/modals/ModalGroupRemoveHost'
import ModalConfirmRemoveGroup from '@/components/appointment/modals/ModalConfirmRemoveGroup'
import ModalAddAppointmentToGroup from '@/components/appointment/modals/ModalAddAppointmentToGroup'
import ModalAppointmentVisitorEdit from '@/components/appointment/modals/ModalAppointmentVisitorEdit'
import ModalAppointmentRemoveFromGroup from '@/components/appointment/modals/ModalAppointmentRemoveFromGroup'

import ModalBulkCancel from '@/components/appointment/modals/ModalBulkCancel'
import ModalBulkReschedule from '@/components/appointment/modals/ModalBulkReschedule'
import ModalConfirmAppointmentManually from '@/components/appointment/modals/ModalConfirmAppointmentManually'
import ModalBulkSendConfirmationEmail from '@/components/appointment/modals/ModalBulkSendConfirmationEmail'

import ModalUpdateAdditionalInfo from '@/components/appointment/modals/ModalUpdateAdditionalInfo'
import ModalUpdateAdditionalInfoConfirmToClose from '@/components/appointment/modals/ModalUpdateAdditionalInfoConfirmToClose'
import AppointmentUpdateObservations from '@/components/appointment/AppointmentUpdateObservations'
import AppointmentUpdateDisplacement from '@/components/appointment/AppointmentUpdateDisplacement'
import AppointmentChangeInspector from '@/components/appointment/AppointmentChangeInspector'

export default {
  name: 'SelectedMarkersModals',

  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },

    appointment: {
      type: Object,
      required: false,
    },

    selectedAppointments: {
      type: Array,
      required: false,
    },
  },

  components: {
    ModalGroupSetHost,
    ModalGroupRemoveHost,
    ModalConfirmRemoveGroup,
    ModalAddAppointmentToGroup,

    AppointmentCancel,
    AppointmentReschedule,
    AdminAppointmentAddHost,
    AdminAppointmentChangeDate,
    AdminAppointmentChangeHost,
    AdminAppointmentChangeType,
    AdminAppointmentQuoteReopen,
    AdminAppointmentChangeStatus,
    AdminAppointmentChangeKeyLocation,
    ModalAppointmentRemoveFromGroup,
    ModalAppointmentVisitorEdit,

    ModalUpdateAdditionalInfo,
    ModalUpdateAdditionalInfoConfirmToClose,

    ModalConfirmAppointmentManually,
    ModalBulkReschedule,
    ModalBulkCancel,
    ModalBulkSendConfirmationEmail,
    AppointmentUpdateObservations,
    AppointmentUpdateDisplacement,
    AppointmentChangeInspector,
  },

  computed: {
    additionalData() {
      return this.appointment?.additional_data ?? []
    },

    /**
     * O board e a lista do portal não passam o agendamento por prop — só a lista do admin passa.
     * O menu já carrega o agendamento na store antes de abrir o modal, então caímos nela: sem isso
     * o formulário abre sem dados e o submit quebra em `appointment.id`.
     */
    appointmentToConfirm() {
      const fromStore = this.$store.getters.appointment
      return this.appointment?.id ? this.appointment : fromStore
    },
  },

  methods: {
    refreshAppointments() {
      this.$emit('refreshAppointments')
    },
  },
}
</script>
